import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { MenuItemInterface } from '../../interfaces/menu-item.interface';
import { ReplaceBusinessUnitIdPipe } from '../../pipes/replace-business-unit-id.pipe';
import { asyncScheduler } from 'rxjs';
import { LocalStorageService } from '@services/local-storage.service';
import { ServiceRequestTypeDynamicNumberInterface } from '../../interfaces/service-request-type-dynamic-number.interface';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-sidebar-menu-item',
  standalone: true,
  imports: [CommonModule, RouterLink, MatExpansionModule, RouterLinkActive, ReplaceBusinessUnitIdPipe, MatIconModule],
  templateUrl: './sidebar-menu-item.component.html',
  styleUrls: ['./sidebar-menu-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarMenuItemComponent {
  @ViewChild('expansionPanel') expansionPanel: MatExpansionPanel | null = null;

  @Input() menuItem: MenuItemInterface | null = null;
  @Input() serviceRequestDynamicData: ServiceRequestTypeDynamicNumberInterface | null = null;
  @Input() serviceRequestQueue: number | null = null;
  @Input() assignedIssuesCount: number | null = null;

  /**
   * Open expansion panel after sidebar open animation finishes on sidebar open, or close it on sidebar close
   *
   * @param value - isMenuOpen value
   */
  @Input() set isMenuOpen(value: boolean) {
    this._isMenuOpen = value;

    if (!this.expansionPanel) {
      return;
    }

    if (this._isMenuOpen) {
      asyncScheduler.schedule((): void => {
        this.expansionPanel.open();
      }, 250);
    } else {
      this.expansionPanel.close();
    }
  }

  @Output() isMenuOpenChange: EventEmitter<boolean> = new EventEmitter();

  constructor(private readonly localStorageService: LocalStorageService) {}

  _isMenuOpen: boolean;

  businessUnitId = this.localStorageService.getCurrentUserDetails()?.businessUnitId ?? '';
}
